import React, { useEffect, useState } from "react";
import Layout from "../layout";
import { withLocalize } from "react-localize-redux";
import ajaxService from "../services/ajax-service";
import { Input, Button, Form, Toast } from "antd-mobile";
import { Select } from "antd";
import { AimOutlined } from "@ant-design/icons";
import { useHistory, useParams } from "react-router-dom";
import { masalik } from "../constants";

const cities = [{ id: 1, name: "Karachi" }];

const { Option } = Select;

const MasjidForm = ({ translate }) => {
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const router = useHistory();
  //   const [, setLogin] = useAuth();
  //   const dispatch = useDispatch();
  let { id } = useParams();
  const [form] = Form.useForm();

  useEffect(() => {
    const getMasajid = async () => {
      let response = await ajaxService.get("masjid/" + id);

      if (response != null && Object.keys(response.data).length > 0) {
        form.setFieldsValue({ ...response.data });
        setLatitude(parseFloat(response.data.latitude));
        setLongitude(parseFloat(response.data.longitude));
      } else {
        let latitude = localStorage.getItem("latitude");
        let longitude = localStorage.getItem("longitude");

        setTimeout(function () {
          myMap(window.google, latitude, longitude);
        }, 2000);
      }
    };
    getMasajid();
  }, []);

  const onFinish = async (values) => {
    if (
      latitude === undefined ||
      longitude === undefined ||
      latitude === null ||
      longitude === null
    ) {
      Toast.show({ content: translate("google_error") });
    } else {
      values.latitude = latitude;
      values.longitude = longitude;

      if (id > 0) {
        let response = await ajaxService.put("masjid/" + id, values);

        if (response != null) {
          router.push({ pathname: "/masjid-list" });
        }
      } else {
        console.log(values);
        let response = await ajaxService.post("masjid", values);

        if (response != null) {
          router.push({ pathname: "/masjid-list" });
        }
      }
    }
  };

  useEffect(() => {
    const script = document.createElement("script");

    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyAcVMG51SU_xSnFuTV0slIPLxSQCAKt5_E&libraries=geometry";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const myMap = (google, latitude, longitude) => {
    const myCenter = new google.maps.LatLng(latitude, longitude);

    const mapOptions = {
      center: myCenter,
      zoom: 17,
      disableDefaultUI: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };

    const mapCanvas = document.getElementById("map");
    const map = new google.maps.Map(mapCanvas, mapOptions);

    var marker = new google.maps.Marker({ position: myCenter });

    marker.setMap(map);

    google.maps.event.addListener(map, "click", function (event) {
      marker.setPosition(event.latLng);
      const pos = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };
      //map.setCenter(pos);
      setLatitude(pos.lat);
      setLongitude(pos.lng);
    });
  };

  useEffect(() => {
    if (latitude > 0 && longitude > 0) {
      myMap(window.google, latitude, longitude);
    }
  }, [latitude, longitude]);

  const handleClick = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLatitude(position.coords.latitude);
        setLongitude(position.coords.longitude);
      },
      () => alert("Location access is blocked. Please allow location access")
    );
  };

  return (
    <Layout title={translate("masjid")}>
      <div
        style={{
          marginLeft: "30px",
          marginRight: "30px",
          height: document.body.clientHeight,
          height: "calc(100vh - 100px)",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            width: "100%",
            height: "100%",
            marginTop: "10px",
          }}
        >
          <Form
            onFinish={onFinish}
            form={form}
            footer={
              <Button block type="submit" color="primary" size="large">
                Submit
              </Button>
            }
            mode="card"
          >
            <Form.Item
              name="name"
              label="Name"
              rules={[{ required: true, message: "Name field is required" }]}
            >
              <Input placeholder="Name" />
            </Form.Item>
            <Form.Item
              name="name_ur"
              label="Urdu Name"
              rules={[
                { required: true, message: "Urdu name field is required" },
              ]}
            >
              <Input placeholder="Urdu Name" />
            </Form.Item>
            <Form.Item
              name="phone"
              label="Phone"
              rules={[{ required: true, message: "Phone field is required" }]}
            >
              <Input placeholder="Phone" />
            </Form.Item>
            <Form.Item
              name="location"
              label="Location"
              rules={[
                { required: true, message: "Location field is required" },
              ]}
            >
              <Input placeholder="Location" />
            </Form.Item>

            <Form.Item label={translate("maslak")} name="maslak">
              <Select style={{ width: "100%" }}>
                {masalik.map((maslak, index) => {
                  return (
                    <Option value={index} key={"maslak-" + index}>
                      {translate(maslak)}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>

            <Form.Item label={translate("city")} name="city_id">
              <Select style={{ width: "100%" }}>
                {cities.map((city, index) => {
                  return (
                    <Option value={city.id} key={"city-" + index}>
                      {city.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
            <div
              style={{ width: "100%", height: "250px", position: "relative" }}
            >
              <div id="map" style={{ width: "100%", height: "100%" }}></div>
              <Button
                type="primary"
                shape="circle"
                size="large"
                style={{ position: "absolute", bottom: 5, right: 5 }}
                onClick={handleClick}
              >
                <AimOutlined />
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </Layout>
  );
};

export default withLocalize(MasjidForm);
